import { request } from "@/api/request";

export async function getCampaignList(args) {
  const list = await request({
    url: "/campaigns",
    method: "get",
    params: args,
  });
  return list;
}

export async function createCampaign(args) {
  const rv = await request({
    url: "/campaigns",
    method: "post",
    data: args,
  });
  return rv;
}

export async function loadCampaign(args) {
  const rv = await request({
    url: "/campaigns/" + args.ident,
    method: "get",
  });
  return rv;
}

export async function saveCampaign(args, payload) {
  const campaign = await request({
    url: "/campaigns/" + args.ident,
    method: "post",
    params: {
      validate: args.validate,
    },
    data: payload,
  });
  return campaign;
}

export async function submitCampaign(args) {
  const rv = await request({
    url: "/campaigns/" + args.ident + "/submit",
    method: "post",
  });
  return rv;
}

export async function getTagsList(args) {
  const list = await request({
    url: "/ac/tags",
    method: "get",
    params: args,
  });
  return list;
}

export async function createNewTag(args) {
  const tag = await request({
    url: "/tags",
    method: "post",
    data: args,
  });
  return tag;
}

export async function apiCloneCampaign(args) {
  const rv = await request({
    url: "/campaigns/" + args.sourceIdent + "/clone",
    method: "post",
  });
  return rv;
}

export async function apiToggleListable(args) {
  const rv = await request({
    url: "/campaigns/" + args.campaignIdent + "/toggle-listable",
    method: "post",
  });
  return rv.listable;
}

export async function apiDeleteCampaign(args) {
  const rv = await request({
    url: "/campaigns/" + args.campaignIdent,
    method: "delete",
  });
  return rv;
}

export async function apiGetMultipleCodes(args) {
  const rv = await request({
    url: "/campaigns/" + args.campaignIdent + "/multiple-codes",
    method: "get",
  });
  return rv;
}

export async function apiAddMultipleCodes(args, payload) {
  const rv = await request({
    url: "/campaigns/" + args.campaignIdent + "/multiple-codes",
    method: "post",
    data: payload,
  });
  return rv;
}

export async function apiUploadCodes(args, file) {
  const formData = new FormData();
  formData.append("upload", file, file.name);
  const rv = await request({
    url: "/campaigns/" + args.campaignIdent + "/multiple-codes/upload",
    method: "post",
    data: formData,
    config: { headers: { "Content-Type": "multipart/form-data" } },
  });
  return rv;
}

export async function apiDownloadCodes(args) {
  const rv = await request({
    url: "/campaigns/" + args.campaignIdent + "/multiple-codes/download",
    method: "get",
    responseType: "blob",
  });
  return rv;
}

export async function apiGetStatusHistory(args) {
  const rv = await request({
    url: "/campaigns/" + args.campaignIdent + "/status-history",
    method: "get",
  });
  return rv;
}

export async function apiGetFollowupList(args) {
  const rv = await request({
    url: "/campaigns/" + args.campaignIdent + "/followups",
    method: "get",
  });
  return rv;
}

export async function apiCreateFollowupLink(args) {
  const rv = await request({
    url: "/campaigns/" + args.campaignIdent + "/followups",
    method: "post",
    data: args,
  });
  return rv;
}

export async function apiDeleteFollowupLink(args) {
  const rv = await request({
    url: "/campaigns/" + args.campaignIdent + "/followups",
    method: "delete",
    data: args,
  });
  return rv;
}

export async function apiCreateFollowupCampaign(args) {
  const rv = await request({
    url: "/campaigns/" + args.campaignIdent + "/create-followup",
    method: "post",
    data: args,
  });
  return rv;
}
